module.exports = __webpack_public_path__ + "img/certificate-2.a2949cc0.png";